import { OpenStreetMapProvider } from 'leaflet-geosearch';

export const client = new OpenStreetMapProvider({
    params: {
        'accept-language': 'en',
        countrycodes: 'us',
        addressdetails: 1,
    },
});